import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { RouteTrackingService } from 'src/app/common/services/route-tracking.service';

@Component({
  selector: 'app-access-denied',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule
  ],
  templateUrl: './access-denied.component.html'
})
export class AccessDeniedComponent implements OnInit {
  previousUrl!: string | string[];

  constructor(
    private router: Router,
    private routerTrackingService: RouteTrackingService
  ) {
   }

  ngOnInit(): void {
    // 1. this route
    // 2. previous route for which there's no access
    // 3. route before the previous route
    this.previousUrl = this.routerTrackingService.getUrlFromHistory(3);
  }

  goBack(): void {
    this.routerTrackingService.removeLastUrl();
    this.routerTrackingService.removeLastUrl();
  }

}
